import { NICmsContentField } from '@icms/core/content';
import { NProductSizeGuideModal } from './product-size-guide-modal.interface';
export const PRODUCT_SIZE_GUIDE_BLOCK_CONFIG = {
    id: NProductSizeGuideModal.BLOCK_ID,
    block: {
        url: NProductSizeGuideModal.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Size Guide Popup',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'tables',
            title: 'Tables',
            itemName: 'table',
            itemNameField: 'tables',
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.toggle,
                    key: 'toggleVisibility',
                    title: 'Toggle Visibility'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'toggleTitle',
                    title: 'Toggle Title',
                    canShow: data => data?.toggleVisibility
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'toggleOptionFirst',
                    title: 'Toggle Option First',
                    canShow: data => data?.toggleVisibility
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'toggleOptionSecond',
                    title: 'Toggle Option Second',
                    canShow: data => data?.toggleVisibility
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'tableCopy',
                    title: 'Table Copy'
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'rows',
                    title: 'Table',
                    itemName: 'row',
                    itemNameField: 'rows',
                    required: true,
                    fields: [
                        <NICmsContentField.IRepeaterField>{
                            type: NICmsContentField.EFieldType.repeater,
                            key: 'columns',
                            title: 'Columns',
                            itemName: 'column',
                            fields: [
                                <NICmsContentField.IField>{
                                    type: NICmsContentField.EFieldType.text,
                                    key: 'valueFirst',
                                    title: 'Value First'
                                },
                                <NICmsContentField.IField>{
                                    type: NICmsContentField.EFieldType.text,
                                    key: 'valueSecond',
                                    title: 'Value Second'
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'copy',
            title: 'Copy'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'imageTitle',
            title: 'Image Title'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.textarea,
            key: 'imageCaption',
            title: 'Image Caption'
        }
    ]
};
